import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import {
  Image,
  Stack,
  useDisclosure
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import { motion } from 'framer-motion'
import L from 'leaflet'
import {
  authSelectors,
  chatCredentialsSelectors,
  getNotificationMessage,
  handleOpenModal,
  markersSelectors,
  setBlogParent,
  getComments,
  setComments,
  setIsBlogFormOpen,
  setIsProfileSwitched,
  setLiveLocData,
  setOpenBlogForm,
  setSocMedDisplay,
  setSocMedDisplayStatus,
  setUserSectionPage,
  usersSelectors,
  setExecAutoArchive,
  setClosePane,
  setOnPostEditor,
  setRepostThisPostData
} from 'store'
import {
  liveMarkerUpdate,
  staticMarkerUpdate
} from 'store/markers/axios'
import {
  BLOGS,
  EDIT_PROFILE,
  FORGOT_PASSWORD,
  MODAL_SECTION,
  MY_PROFILES,
  REJECTED,
  SETTINGS,
  SIGN_IN,
  SIGN_UP,
  LOCATION_TYPE,
  PENDING
} from 'utils/constants'
import {
  getUrlParams,
  isAuth,
  isNotMobile,
  showCoordParams
} from 'utils/helpers'
import { COLORS } from 'utils/styles'

/* eslint-disable import/no-cycle */
import { Messenger } from 'components'
import { SearchContainer } from 'components/SearchContainer'
import { UserDrawer } from 'components/Header/UserDrawer'

const MotionStack = motion(Stack)

export const Header = () => {
  const { verificationEmailStandBy } = useSelector(authSelectors)
  const { xmppLiveLocation } = useSelector(chatCredentialsSelectors)
  const {
    user,
    activeProfile,
    blogParent,
    getCommentsStatus,
    isBlogFormOpen,
    isCloseModal,
    isSocialMediaSelectOpen,
    isProfileChanged,
    isProfileSwitched,
    userSectionPage,
    onPostEditor,
    chosenBlogIndex,
    closePane,
    closeUserPanel,
    closeAllDrawers,
    markerOpenBeforeLogin
  } = useSelector(usersSelectors)
  const {
    liveMarkerExp,
    selectedMarkerData,
    staticMarkerExp
  } = useSelector(markersSelectors)

  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = useRef()
  const isFirstRender = useRef(true)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isDiscard, setIsDiscard] = useState(false)
  const [isClickedOutside, setIsClickedOutside] = useState(true)
  const [liveReset, setLiveReset] = useState(false)
  const [staticReset, setStaticReset] = useState(false)
  const [updateReset, setUpdateReset] = useState(false)
  const [dynamicIsOpen, setDynamicIsOpen] = useState(false)
  const isBlogForMobile = () => isBlogFormOpen && !isNotMobile()
  const [blogFinishAnimation, setBlogFinishAnimation] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()

  let id = sessionStorage.getItem('id')
  let intervalRef = useRef()
  const usePhoto = activeProfile && activeProfile.profile_picture
  if (localStorage.getItem('isLocDisabled') === null) {
    localStorage.setItem('isLocDisabled', false)
  }

  const goToHeaderOriginalPos = (parentData) => {
    const drawer = document.querySelector(`#${BLOGS}-drawer-body`)
    const targetElement = document.querySelector('#blogStartItem' + chosenBlogIndex)

    if (
      drawer
      && parentData?.parent_type
    ) {
      drawer.scrollTo({
        top: 0,
        behavior: 'auto'
      })
    } else if (
      drawer
      && targetElement
    ) {
      requestAnimationFrame(() => {
        const containerTop = drawer.getBoundingClientRect().top
        const elementTop = targetElement.getBoundingClientRect().top
        const scrollDifference = Math.floor(elementTop) - containerTop

        drawer.scrollTop += scrollDifference
      })
    }
  }

  const handleCloseButton = () => {
    setIsClickedOutside(userSectionPage.at(-1) !== EDIT_PROFILE)

    if (
      isAuth()
      && user
    ) {
      if (userSectionPage.at(-1) === MY_PROFILES) {
        dispatch(setUserSectionPage(null))
        onClose()
      } else if (
        userSectionPage.at(-1) === EDIT_PROFILE
        && isProfileChanged === true
        && isSocialMediaSelectOpen === false
      ) {
        setIsDiscard(true)
      } else if (
        (
          userSectionPage.at(-1) === EDIT_PROFILE
          && isProfileChanged === false
          && isSocialMediaSelectOpen === false
        )
        || userSectionPage.at(-1) === BLOGS
      ) {
        if (blogParent.length) {
          if (
            blogParent.length > 1
            && getCommentsStatus === PENDING
          ) {
            dispatch(getNotificationMessage({
              type: REJECTED,
              message: 'Please finish loading first before returning to previous blog post or comment',
              isEditProfile: true
            }))
          } else {
            const parentData = blogParent[blogParent.length - 1]

            goToHeaderOriginalPos(parentData)

            dispatch(setComments([]))
            if (parentData?.parent_type) {
              dispatch(getComments({
                type: parentData.parent_type,
                ...(parentData.parent_type === 'post' ? { post_id: parentData.post_id } : { comment_id: parentData.parent_comment_id })
              }))
            }
          }

          dispatch(setBlogParent(blogParent.slice(0, -1)))
        } else {
          dispatch(setUserSectionPage(null))
        }
      } else if (
        userSectionPage.at(-1) === EDIT_PROFILE
        && isSocialMediaSelectOpen === true
      ) {
        dispatch(setSocMedDisplayStatus('none'))
        dispatch(setSocMedDisplay(false))
      } else {
        dispatch(setUserSectionPage(null))
      }
    } else if (userSectionPage.at(-1) === SIGN_IN) {
      dispatch(setUserSectionPage('clear'))
      onClose()
    } else if (
      !isAuth()
      && !user
      && (
        userSectionPage.at(-1) === FORGOT_PASSWORD
        || userSectionPage.at(-1) === SIGN_UP
      )
    ) {
      dispatch(setUserSectionPage(null))
    } else {
      dispatch(setUserSectionPage(SIGN_IN))
    }
  }

  const handleSettingButton = () => {
    setIsClickedOutside(false)

    if (
      userSectionPage.at(-1) === EDIT_PROFILE
      && isProfileChanged === true
    ) {
      setIsDiscard(true)
    } else if (
      userSectionPage.at(-1) === BLOGS
      && onPostEditor === 'post'
    ) {
      dispatch(setExecAutoArchive(true))
      dispatch(setOnPostEditor(''))
      setTimeout(() => dispatch(setUserSectionPage(SETTINGS)), 600)
    } else {
      dispatch(setUserSectionPage(SETTINGS))
    }
  }

  useEffect(() => {
    if (userSectionPage.at(-1) === EDIT_PROFILE) {
      setIsClickedOutside(true)
    }
  }, [userSectionPage])

  useEffect(() => {
    if (closePane) {
      dispatch(setClosePane(false))
      handleCloseButton()
    }
  }, [closePane])

  useEffect(() => {
    if (
      getUrlParams('token', 'email')[0]
      && getUrlParams('token', 'email')[1]
    ) {
      onOpen()
    }
  }, [])

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    navigate('/')
    dispatch(handleOpenModal({ isOpen, section: MODAL_SECTION.LeftSection }))

    const customPopupOverlay = document.querySelector('#custom-popup-overlay')
    const customPopupOverlayEvent = document.querySelector('#custom-popup-overlay-event')
    if (customPopupOverlay && isAuth() && !markerOpenBeforeLogin) {
      customPopupOverlay.click()
    } else if (customPopupOverlayEvent && isAuth() && !markerOpenBeforeLogin) {
      customPopupOverlayEvent.click()
    }

    // The timeout is used to ensure other drawers/modals are closed before opening
    // Also used for the timing of fiter items' animation to left
    setTimeout(() => {
      setTimeout(() => setDynamicIsOpen(isOpen), isOpen ? 0 : 50)

      setTimeout(() => {
        if (!isOpen && document.querySelectorAll('.chakra-modal__content').length === 0) {
          showCoordParams(setSearchParams)
        }

        if (!isOpen) {
          dispatch(setRepostThisPostData({}))
        }
      }, 200)
    }, isOpen ? 200 : 850)
  }, [isOpen])

  useEffect(() => {
    dispatch(setUserSectionPage('clear'))
    onClose()
  }, [isCloseModal])

  const getRandomDecimalWithPrecision = (min, max, precision) => {
    const factor = 10 ** precision
    min *= factor
    max *= factor
    return (Math.floor(Math.random() * (max - min + 1)) + min) / factor
  }

  // User Live Loc Update
  useEffect(() => {
    const activeID = activeProfile?.id
    const activeLocType = activeProfile?.location_type
    const activeCoordinates = activeProfile?.coordinates
    let addRadiusLat = 0
    let addRadiusLng = 0

    if (
      (
        activeID
        && (
          activeLocType?.[LOCATION_TYPE.LiveLocation] === 0
          || activeLocType?.[LOCATION_TYPE.LiveApproximate] === 1
        )
      )
      && Number.isNaN(xmppLiveLocation?.lat) === false
    ) {
      if (activeLocType?.[LOCATION_TYPE.LiveApproximate] === 1) {
        addRadiusLat = getRandomDecimalWithPrecision(-0.001, 0.001, 4)
        addRadiusLng = getRandomDecimalWithPrecision(-0.001, 0.001, 4)
      }

      let newCoords = {
        lat: Number((parseFloat(xmppLiveLocation?.lat) + addRadiusLat).toFixed(6)),
        lng: Number((parseFloat(xmppLiveLocation?.lng) + addRadiusLng).toFixed(6))
      }

      setTimeout(() => {
        if (
          activeCoordinates?.lat !== xmppLiveLocation?.lat
          && activeCoordinates?.lng !== xmppLiveLocation?.lng
          && sessionStorage.getItem('id') === null
        ) {
          const distance = (L.latLng(activeCoordinates)).distanceTo(L.latLng(xmppLiveLocation))

          // check whether the distance between the old and new coords is >= 10 meters
          if (distance >= 10) {
            dispatch(setLiveLocData({ id: activeID, coordinates: newCoords }))
          }
        }
        setUpdateReset(!updateReset)
      }, 60000)
    } else {
      setTimeout(() => setUpdateReset(!updateReset), 5000)
    }
  }, [updateReset])

  // Live Update Interval
  useEffect(() => {
    let currentDate = new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: false })
    if (liveMarkerExp) {
      let liveMarkerDate = new Date(liveMarkerExp).toLocaleString('en-US', { hour12: false })
      let northeast = JSON.parse(localStorage.getItem('northeast'))
      let southwest = JSON.parse(localStorage.getItem('southwest'))

      setTimeout(() => {
        if (
          currentDate >= liveMarkerDate
          && sessionStorage.getItem('id') === null
          && localStorage.getItem('isNotifOpen') === 'false'
        ) {
          dispatch(liveMarkerUpdate({
            isAuth: isAuth(),
            northeast,
            southwest
          }))
        }
        setLiveReset(!liveReset)
      }, 60000)
    } else {
      setTimeout(() => setLiveReset(!liveReset), 5000)
    }
  }, [liveReset])

  // Static Update Interval
  useEffect(() => {
    let currentDate = new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: false })
    if (staticMarkerExp) {
      let staticMarkerDate = new Date(staticMarkerExp).toLocaleString('en-US', { hour12: false })
      let northeast = JSON.parse(localStorage.getItem('northeast'))
      let southwest = JSON.parse(localStorage.getItem('southwest'))

      setTimeout(() => {
        if (
          currentDate >= staticMarkerDate
          && sessionStorage.getItem('id') === null
          && localStorage.getItem('isNotifOpen') === 'false'
        ) {
          dispatch(staticMarkerUpdate({
            isAuth: isAuth(),
            northeast,
            southwest
          }))
        }
        setStaticReset(!staticReset)
      }, 60000)
    } else {
      setTimeout(() => setStaticReset(!staticReset), 5000)
    }
  }, [staticReset])

  useEffect(() => {
    if (isProfileSwitched === true) {
      clearInterval(intervalRef.current)
      dispatch(setIsProfileSwitched(false))
    }
  }, [isProfileSwitched])

  useEffect(() => {
    setTimeout(() => setBlogFinishAnimation(isBlogForMobile()), 350)
  }, [isBlogFormOpen])

  useEffect(() => {
    if (closeUserPanel) {
      dispatch(setUserSectionPage('clear'))
      onClose()
    }
  }, [closeUserPanel])

  useEffect(() => {
    if (closeAllDrawers) {
      dispatch(setUserSectionPage('clear'))
      onClose()
    }
  }, [closeAllDrawers])

  useEffect(() => {
    if (verificationEmailStandBy) {
      dispatch(setUserSectionPage('clear'))
      onClose()
    }
  }, [verificationEmailStandBy])

  return (
    <>
      <MotionStack
        background={COLORS.gold}
        className="header"
      >
        <MotionStack
          initial={{ y: 0 }}
          animate={{ y: isBlogForMobile() ? -50 : 0 }}
          transition={{
            type: 'tween',
            duration: 0.8
          }}
          display="flex"
          justifyContent="center"
          paddingBlock="9px"
          spacing="10px"
          direction="row"
          alignItems="center"
          background={COLORS.gold}
        >
          {isAuth() ? (
            <Image
              boxSize="32px"
              cursor="pointer"
              objectFit="cover"
              src={usePhoto || ImagesPng.UserImage}
              alt="Logo"
              borderRadius="full"
              onClick={() => {
                sessionStorage.removeItem('openProfileAfterAnimation')
                sessionStorage.removeItem('openEventAfterAnimation')

                if (
                  !searchParams.get('id')
                  && !searchParams.get('post-id')
                  && !searchParams.get('eventid')
                  && !selectedMarkerData
                ) {
                  document.querySelector('div.leaflet-container').click()
                  dispatch(setUserSectionPage('clear'))
                  dispatch(setUserSectionPage(MY_PROFILES))
                  dispatch(setIsBlogFormOpen(false))
                  dispatch(setOpenBlogForm(false))
                  onOpen()
                }
              }}
              onLoad={() => {
                if (id !== null && !isAuth()) {
                  onOpen()
                }
              }}
              ref={btnRef}
              className="profile-icon"
            />
          ) : (
            <Image
              as={motion.img}
              animate={{
                scale: [1, 1.1, 1],
                opacity: [1, 0.8, 1],
                transition: {
                  repeat: Infinity,
                  duration: 1
                }
              }}
              boxSize="32px"
              cursor="pointer"
              objectFit="cover"
              src={usePhoto || ImagesPng.UserImage}
              alt="Logo"
              borderRadius="full"
              onClick={() => {
                if (isAuth()) {
                  document.querySelector('div.leaflet-container').click()
                }

                dispatch(setUserSectionPage('clear'))
                dispatch(setUserSectionPage(SIGN_IN))
                onOpen()
              }}
              ref={btnRef}
              className="profile-icon"
            />
          )}

          <SearchContainer />

          <Messenger />
        </MotionStack>
      </MotionStack>

      <UserDrawer
        onClose={onClose}
        dynamicIsOpen={dynamicIsOpen}
        isDiscard={isDiscard}
        setIsDiscard={setIsDiscard}
        blogFinishAnimation={blogFinishAnimation}
        isClickedOutside={isClickedOutside}
        setIsClickedOutside={setIsClickedOutside}
        isBlogForMobile={isBlogForMobile}
        handleCloseButton={handleCloseButton}
        handleSettingButton={handleSettingButton}
      />
    </>
  )
}
